import { render, staticRenderFns } from "./order_return_express.vue?vue&type=template&id=4987764f&scoped=true"
import script from "./order_return_express.vue?vue&type=script&lang=js"
export * from "./order_return_express.vue?vue&type=script&lang=js"
import style0 from "./order_return_express.vue?vue&type=style&index=0&id=4987764f&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4987764f",
  null
  
)

export default component.exports